/* Danella buy box helpers: a "per product" price next to the main price, and the savings explainer tucked into "See the math".
   Does nothing on pages without a routine size picker. */
(function(){
  function init(){
    if(window.__dbBuybox)return;
    var price=document.querySelector('.product-info__sticky [data-product-price]');
    var sel=document.querySelector('select[data-variant-select]');
    if(!price||!sel)return;
    var wrap=price.closest('.price');
    if(!wrap)return;
    window.__dbBuybox=true;
    var per=document.createElement('span');
    per.className='price__per';
    per.hidden=true;
    function steps(){
      var o=sel.options[sel.selectedIndex];
      var m=o&&/(\d+)\s*-\s*step/i.exec(o.textContent||'');
      return m?parseInt(m[1],10):0;
    }
    function cents(){
      var o=sel.options[sel.selectedIndex];
      var r=o&&Number(o.getAttribute('data-price-raw'));
      if(r>0)return r;
      var t=parseFloat((price.textContent||'').replace(/[^0-9.]/g,''));
      return t>0?Math.round(t*100):0;
    }
    function update(){
      var k=steps(),c=cents();
      if(!wrap.contains(per))price.insertAdjacentElement('afterend',per);
      if(k>1&&c>0){
        var txt='$'+(c/100/k).toFixed(2)+' per product';
        if(per.textContent!==txt)per.textContent=txt;
        if(per.hidden)per.hidden=false;
      }else if(!per.hidden){per.hidden=true;}
    }
    [].forEach.call(document.querySelectorAll('.db-value__same'),function(p){
      var card=p.closest('.db-value__card');
      var d=card&&card.querySelector('details.db-value__math');
      if(d){d.insertBefore(p,d.querySelector('ol'));p.style.margin='.8rem 0 0';}
    });
    document.addEventListener('change',function(e){
      if(e.target&&e.target.matches&&e.target.matches('select[data-variant-select]'))setTimeout(update,0);
    },true);
    document.addEventListener('click',function(e){
      if(e.target.closest&&e.target.closest('[data-db-tier],[data-rgp-tier]'))setTimeout(update,30);
    },true);
    try{new MutationObserver(update).observe(price,{childList:true,characterData:true,subtree:true});}catch(err){}
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  window.addEventListener('pageshow',function(){if(window.__dbBuybox)return;init();});
})();